import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileDevPageSide300x250Fs from './freestar/MobileDevPageSide300x250';
import MobileDevPageSide300x250Tab from './taboola/MobileDevPageSide300x250';
const MobileDevPageSide300x250 = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Tab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(MobileDevPageSide300x250Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
